export default __webpack_public_path__ + "static/Bitrate_Test_12_h264_hp_1600000-3e7b96e79ab4d6ba870f1f209c2da360.avif";